import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import moment from "moment";
import React from "react";

function CommunityStatsTable({ data }) {

  const columns = [
    {
      accessor: "first_name",
      Header: "first Name",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "phone_number",
      Header: "Phone Number",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "email",
      Header: "Email",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "orderDisplayId",
      Header: "Order Display Id",
      headerProps: { className: "text-900" },
    },
    {
      accessor: (row) => moment(row?.latest_order_placed).format("YYYY-MM-DD"),
      Header: "Latest Order Placed",
      headerProps: { className: "text-900" },
    },
  ];

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data || []}
      sortable
      pagination
      perPage={10}
    >
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
    </AdvanceTableWrapper>
  );
}

export default CommunityStatsTable;
